import { render, staticRenderFns } from "./messList.vue?vue&type=template&id=071b02c6&"
import script from "./messList.vue?vue&type=script&lang=js&"
export * from "./messList.vue?vue&type=script&lang=js&"
import style0 from "./messList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports